import styled from 'styled-components';

import Btn from 'components/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
`;

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  gap: 8px;
`;

export const Button = styled(Btn)`
  width: 100%;
  height: 40px;
  padding: 0 6px;
  font-size: var(--font-size11);
  font-weight: var(--font-weight500);
  letter-spacing: 0.92px;
  color: var(--color-grey6A);
  word-break: break-word;
  text-align: center;
`;
